import { apiDownload, apiRequest } from "./client";
import { normalizeListPayload } from "../utils/pagination";

const toQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const value = search.toString();
  return value ? `?${value}` : "";
};

export const fetchAuditLogs = async (params = {}) => {
  const payload = await apiRequest(
    `/audit-logs${toQuery({
      sort_by: "created_at",
      sort_order: "desc",
      page: 1,
      per_page: 20,
      ...params,
    })}`
  );

  const { items: logs, meta } = normalizeListPayload(payload, {
    itemKeys: ["logs", "audit_logs"],
    perPage: params.per_page,
  });
  const body = payload?.data && !Array.isArray(payload.data) ? payload.data : payload;

  const modules = Array.isArray(body?.modules)
    ? body.modules
    : [...new Set(logs.map((entry) => entry.module).filter(Boolean))];

  const actions = Array.isArray(body?.actions)
    ? body.actions
    : [...new Set(logs.map((entry) => entry.action).filter(Boolean))];

  return { logs, modules, actions, meta, summary: body?.summary };
};

export const exportAuditLogs = async (params = {}) =>
  apiDownload(
    `/audit-logs/export${toQuery({
      sort_by: "created_at",
      sort_order: "desc",
      ...params,
    })}`,
    { filename: "hin-ho-lee-audit.csv" }
  );
